module.exports = __webpack_public_path__ + "img/sloth.9ba46139.gif";